module.exports = __webpack_public_path__ + "static/media/SqlBlog.3a940c57.png";